















import {
  computed, defineComponent,
} from '@nuxtjs/composition-api';

import SvgImage from '~/components/General/SvgImage.vue';
import isServer from '~/helpers/isServer';
import { Logger } from '~/helpers/logger';

export default defineComponent({
  name: 'WebShare',
  components: { SvgImage },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const isSupported = computed(() => !isServer && navigator.share);

    const handleShare = async () => {
      if (navigator.share) {
        try {
          await navigator.share({
            title: props.title,
            text: props.text,
            url: props.url || window.location.href,
          });
        } catch (err) {
          Logger.error('WebShare/handleShare', err);
        }
      }
    };

    return {
      isSupported,
      handleShare,
    };
  },
});
